import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatCardModule } from '@angular/material/card';
import { SHARED_IMPORTS } from 'src/app/shared/standalone-imports';
import { BUILD_INFO } from '../../../../environments/build-info';

interface LicenseDependency {
  name: string;
  version: string;
  license: string;
  homepage?: string;
  repository?: string;
}

@Component({
  selector: 'app-license',
  imports: [
    ...SHARED_IMPORTS,
    MatCardModule,
  ],
  templateUrl: './license.component.html',
  styleUrl: './license.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LicenseComponent implements OnInit {
  private readonly http = inject(HttpClient);
  buildDate = BUILD_INFO.buildDate;
  
  readonly deps = signal<LicenseDependency[]>([]);

  ngOnInit(): void {
    this.http.get<LicenseDependency[]>('assets/licenses/dependencies.json').subscribe({
      next: data => this.deps.set(data),
    });
  }
}
